import { cn } from '@zep/utils';
import { SALES_MAP_EMBED_URLS, SalesMapEmbed } from '../../components/service/common/SalesMapEmbed';
export const ContactEnterpriseView = () => {
  return <div className="flex flex-col bg-gray-50 pb-[48px] pt-[40px] md:pb-[98px] md:pt-[50px]" data-sentry-component="ContactEnterpriseView" data-sentry-source-file="ContactEnterpriseView.tsx">
      <div className="mb-2">
        <div className={cn('text-center font-bold text-gray-900 mb-4', 'text-[18px] leading-[25px]', 'md:text-2xl md:leading-8')}>
          대규모 이용 및 서포트가 필요하신가요?
          <br />
          ZEP 전문 컨설턴트가 상담을 도와드립니다.
        </div>
        <div className={cn('text-center font-medium text-gray-600', 'md:text-[13px] md:leading-[18px]')}>
          아래 양식을 작성 후 제출해 주시면 <br />
          담당자가 빠른 시일 내에 연락드리겠습니다
        </div>
      </div>
      <div className="px-4 md:px-6">
        <SalesMapEmbed webFormUrl={`${SALES_MAP_EMBED_URLS.엔터프라이즈_문의}`} data-sentry-element="SalesMapEmbed" data-sentry-source-file="ContactEnterpriseView.tsx" />
      </div>
    </div>;
};